module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av446-2fbb77c09290b4effd26e2d10e52ca31.jpg";